import { createMultimediaRequest } from "@services/multimedia/multimediaApi";
import { inferMediaType, resolveMediaUrl } from "@utils/media/mediaUrl";

export async function uploadTourSectionImage(file, fallbackId) {
  const response = await createMultimediaRequest({ file });
  const body = response?.body || {};
  const rawItem = Array.isArray(body?.multimediaList)
    ? body.multimediaList[0]
    : Array.isArray(body?.multimedia)
      ? body.multimedia[0]
      : body?.multimedia || null;
  if (!rawItem) throw new Error("Could not upload image.");
  const rawUrl = rawItem?.url || rawItem?.mmd_url || "";
  return {
    imageUrl: resolveMediaUrl(rawUrl),
    image: {
      id: rawItem?.id || rawItem?.mmd_id || `${fallbackId}-image`,
      url: resolveMediaUrl(rawUrl),
      mediaType:
        rawItem?.mediaType || rawItem?.mmd_media_type || inferMediaType(rawUrl),
      mimeType: rawItem?.mimeType || rawItem?.mmd_mime_type || "image/*",
    },
  };
}
